import { render } from "./prompts-generator.vue?vue&type=template&id=47f1ff20&lang=pug"
import script from "./prompts-generator.vue?vue&type=script&lang=js"
export * from "./prompts-generator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__